import resource from "../resource";

const endpoints = {
    user: "/user/web/user-management"
};

export default {
    list: data => {
        const request = resource.get(`${endpoints.user}`, {
            params: data
        });
        return request;
    },
    getById: id => {
        const request = resource.get(`${endpoints.user}/${id}`);
        return request;
    },
    createUpdate: data => {
        let request = "";
        if (data.id) {
            const id = data.id;
            delete data.id;
            request = resource.put(`${endpoints.user}/${id}`, data);
        } else {
            request = resource.post(`${endpoints.user}`, data);
        }
        return request;

        // const body = {
        //     service: "user",
        //     url: endpoints.create,
        //     method: "POST",
        //     data_body: data
        // };
        // return body;
    },
    delete: id => {
        const request = resource.delete(`${endpoints.user}/${id}`);
        return request;
    }
};
